module.exports = __webpack_public_path__ + "img/TN.6761fd9a.png";